"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var features = [
    'Live streaming',
    'On demand video',
    'Pay-per-view',
    'Abonnementen',
    'Club TV',
    'Live Highlights',
    'Live tagging',
    'Delivery API',
];
function Features() {
    return react_1.default.createElement("div", { className: 'storybook-subscriptions-features' }, features.map(function (feature, index) { return react_1.default.createElement("div", { key: index, className: 'storybook-subscriptions-features-feature' },
        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'check', className: 'storybook-icons-icon text-secondary mr-2' }),
        feature); }));
}
exports.default = Features;
